<template>
  <div>
    <v-dialog
      v-if="habilitarInfoAgendamento"
      :value="value"
      @input="$emit('input', $event)"
      :close-on-content-click="false"
      max-width="1200"
      content-class="modal-visualizar-agendamento-dialog-content"
      :key="dialogKey"
    >
      <div class="detalhes-agendamento-modal">
        <div class="modal-header">
          <div class="header-content">
            <div class="header-left">
              <div class="header-icon">
                <v-icon>mdi-file-document-plus</v-icon>
              </div>
              <div class="header-text">
                <h2 class="header-title">Detalhes do Agendamento</h2>
              </div>
            </div>
          </div>
        </div>
        <div class="unified-content">
          <v-card class="unified-card">
            <div class="form-content">
            <div v-if="agendamento.tipoAgendamento === 'Consulta'">
              <v-row align="center" class="d-flex justify-center mb-4">
                <v-col cols="12" sm="4" md="3" class="text-center">
                  <v-avatar class="avatar-paciente" color="primary" size="9rem">
                    <img
                      v-if="agendamento.paciente.foto"
                      :src="'https://medsystemcloud-new.s3.us-west-2.amazonaws.com/' + agendamento.paciente.foto"
                    >
                    <v-icon v-else dark size="120">mdi-account</v-icon>
                  </v-avatar>
                </v-col>
                <v-col cols="12" sm="4" md="5" class="text-center">
                  <div class="d-flex align-center justify-center">
                    <span
                      class="font-weight-bold nome-paciente"
                      v-html="nomePaciente"
                    ></span>
                    <v-btn
                      icon
                      small
                      color="primary"
                      class="ml-2"
                      @click="abrirModalEditarPaciente"
                      title="Editar Paciente"
                    >
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                  </div>
                  <br>
                  <span
                    class="font-weight-regular"
                    v-html="formatarTelefone(agendamento.paciente.contato)"
                  ></span>
                  <v-divider vertical></v-divider>

                  <v-col cols="12" sm="12" md="12" class="text-center">
                    <span
                      class="font-weight-bold texto-idade"
                      v-html="calcularIdadeDoPaciente(agendamento.paciente.dataNascimento)"
                    ></span>
                    <br>
                    <span class="font-weight-regular" v-html="agendamento.paciente.cpf"></span>
                    <br>
                    <span class="font-weight-regular">{{ getSexo(agendamento.paciente.sexo) }}</span>
                  </v-col>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row class="mt-4 d-flex justify-center">
                <v-col cols="12" sm="12" md="12" class="d-flex justify-center bloco-agendado-por">
                  <span class="font-weight-bold mr-2 texto-agendado-por">Agendado por:</span>
                  <span class="font-weight-regular texto-usuario">
                    {{ agendamento.usuario.nomeCompleto }}
                  </span>
                </v-col>
                <v-col cols="12" sm="12" md="7" class="d-flex justify-center bloco-data-hora">
                  <span
                    class="font-weight-bold texto-data-hora"
                    v-html="dataHoraFormatada"
                  ></span>
                </v-col>
              </v-row>
              <v-chip small label class="mb-1 mt-3 d-flex justify-center" dark color="success">
                <b v-html="agendamento.tipoAgendamento"></b>
              </v-chip>
              <soi-atualiza-situacao-agendamento
                v-if="value"
                :situacao="agendamento.situacaoAgendamento"
                :tipoAgendamento="agendamento.tipoAgendamento"
                :agendamentoId="agendamento.id"
                @clickSituacaoAgendamento="$emit('atualizaSituacao', $event)"
              />
              <v-overlay :value="loading">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </v-overlay>
              <v-row
                v-if="canceladoPeloPaciente"
              >
                <v-col>
                  <v-alert border="left" colored-border type="error" elevation="2" dense class="mt-2">
                    Cancelado pelo Paciente.
                  </v-alert>
                </v-col>
              </v-row>
              <v-row v-else-if="agendamento.situacaoAgendamento === 'Cancelado'">
                <v-col>
                  <v-alert border="left" colored-border type="error" elevation="2" dense class="mt-2">
                    Agendamento Cancelado.
                  </v-alert>
                </v-col>
              </v-row>
              <v-row v-else-if="!agendamento.agendamentoConfirmado">
                <v-col>
                  <v-alert
                    border="left"
                    colored-border
                    type="warning"
                    elevation="2"
                    dense
                    class="mt-2 alerta-confirmacao-agendamento"
                  >
                    <v-row align="center" class="conteudo-alerta-confirmacao">
                      <v-col class="grow mensagem-confirmacao-agendamento">
                        {{ $vuetify.breakpoint.width <= 480 ? 'Agendamento não confirmado.' : 'Agendamento ainda não foi confirmado.' }}
                      </v-col>
                      <v-col class="shrink">
                        <v-tooltip top v-if="agendamentoNoPassado">
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <v-btn :disabled="true">
                                <v-icon left color="success">
                                  mdi-whatsapp
                                </v-icon>
                                Enviar link de confirmação
                              </v-btn>
                            </span>
                          </template>
                          <span>Não é possível enviar link de confirmação para um agendamento no passado.</span>
                        </v-tooltip>
                        <v-btn
                          v-else
                          @click="$emit('confirmar', agendamento.id)"
                        >
                          <v-icon left color="success">
                            mdi-whatsapp
                          </v-icon>
                          {{ $vuetify.breakpoint.width <= 480 ? 'Enviar confirmação' : 'Enviar link de confirmação' }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-alert>
                </v-col>
              </v-row>
              <v-row v-else>
                <v-col>
                  <v-alert border="left" colored-border type="success" elevation="2" dense class="mt-2">
                    Agendamento confirmado!
                  </v-alert>
                </v-col>
              </v-row>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-show="agendamento.situacaoAgendamento === 'Cancelado'"
                    color="#424242"
                    v-bind="attrs"
                    v-on="on"
                    @click="$emit('excluir')"
                    class="icone-excluir-agendamento"
                  >
                    mdi-delete
                  </v-icon>
                </template>
                <span>Clique na lixeira para excluir o agendamento</span>
              </v-tooltip>
            </div>

            <!-- COMPROMISSO VISUAL -->
            <div v-else>
              <v-col cols="12" sm="12" md="12" class="text-center">
                <span class="font-weight-bold texto-descricao">Descrição: </span>
                <b class="font-weight-regular texto-nome-compromisso" v-html="agendamento.name"></b>
              </v-col>
              <v-row>
                <v-col cols="12" sm="12" md="12" class="text-center mb-1">
                  <v-col cols="12" sm="12" md="12" class="d-flex justify-center bloco-agendado-por">
                    <span class="font-weight-bold texto-agendado-por">Agendado por:</span>
                    <span class="font-weight-regular texto-usuario">
                      {{ agendamento.usuario.nomeCompleto }}
                    </span>
                  </v-col>
                  <span
                    class="font-weight-bold mb-1 texto-data-hora"
                    v-html="dataHoraFormatada"
                  ></span>
                </v-col>
              </v-row>
              <v-row></v-row>
              <v-chip small label class="mb-1 d-flex justify-center" dark color="yellow darken-2">
                <b v-html="agendamento.tipoAgendamento"></b>
              </v-chip>
              <soi-atualiza-situacao-agendamento
                v-if="value"
                :situacao="agendamento.situacaoAgendamento"
                :agendamentoId="agendamento.id"
                :tipoAgendamento="agendamento.tipoAgendamento"
                @clickSituacaoAgendamento="$emit('atualizaSituacao', $event)"
              />
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-show="agendamento.situacaoAgendamento === 'Cancelado'"
                    color="#424242"
                    v-bind="attrs"
                    v-on="on"
                    @click="$emit('excluir')"
                    class="icone-excluir-agendamento"
                  >
                    mdi-delete
                  </v-icon>
                </template>
                <span>Clique na lixeira para excluir o agendamento</span>
              </v-tooltip>
            </div>
          </div>
          <div class="form-actions">
            <div class="actions-container">
              <v-btn class="action-btn cancel-btn" @click="$emit('input', false)">
                <v-icon left>mdi-keyboard-return</v-icon>
                Cancelar
              </v-btn>
              <v-btn
                class="action-btn edit-btn"
                :disabled="desabilitarEdicao"
                @click="$emit('editar', agendamento.id)"
              >
                <v-icon left>mdi-pencil</v-icon>
                Editar Agendamento
              </v-btn>
            </div>
            </div>
          </v-card>
        </div>
      </div>
    </v-dialog>
    <modal-editar-paciente
      ref="modalEditarPaciente"
      @pacienteEditado="onPacienteEditado"
    />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import DateHelper from '../../helpers/DateHelper';
import Contato from '../../models/objetosDeValor/Contato';
import ModalEditarPaciente from '../paciente/ModalEditarPaciente.vue';

export default Vue.extend({
  name: 'ModalVisualizarAgendamento',
  components: {
    ModalEditarPaciente,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    agendamento: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    dialogKey: {
      type: Number,
      default: 0,
    },
    habilitarInfoAgendamento: {
      type: Boolean,
      default: true,
    },
    desabilitarEdicao: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    nomePaciente(): string {
      if (!this.agendamento?.paciente) {
        return '';
      }
      return !this.agendamento.paciente.usarNomeSocialComoPrincipal
        ? this.agendamento.paciente.nomeCompleto
        : this.agendamento.paciente.nomeSocial;
    },
    dataHoraFormatada(): string {
      if (!this.agendamento?.dataAgendamento || !this.agendamento?.horaAgendamento || !this.agendamento?.end) {
        return '';
      }
      return `${this.agendamento.dataAgendamento} - ${this.agendamento.horaAgendamento} às ${this.formatarHora(this.agendamento.end)}`;
    },
    agendamentoNoPassado(): boolean {
      if (!this.agendamento?.start) {
        return false;
      }

      const dataHora = new Date(this.agendamento.start);
      if (Number.isNaN(dataHora.getTime())) {
        return false;
      }

      return dataHora.getTime() <= Date.now();
    },
    canceladoPeloPaciente(): boolean {
      return this.agendamento?.situacaoAgendamento === 'Cancelado'
        && this.agendamento?.motivoCancelamento === 'CanceladoPeloPaciente';
    },
  },
  watch: {
    value(valor: boolean) {
      this.atualizarClasseModalVisualizarAgendamentoAberto(valor);
    },
  },
  beforeDestroy() {
    this.atualizarClasseModalVisualizarAgendamentoAberto(false);
  },
  methods: {
    atualizarClasseModalVisualizarAgendamentoAberto(modalAberto: boolean) {
      const classe = 'modal-visualizar-agendamento-open';
      if (modalAberto) {
        document.body.classList.add(classe);
      } else {
        document.body.classList.remove(classe);
      }
    },
    formatarTelefone(contato: Contato) {
      const partes = [];

      if (contato && contato.telefonePrincipal) {
        partes.push(contato.telefonePrincipal);
      }

      if (contato && contato.telefoneSecundario) {
        partes.push(contato.telefoneSecundario);
      }

      if (partes.length > 0) {
        return partes.join(' | ');
      }

      return 'Informações de contato não disponíveis';
    },
    calcularIdadeDoPaciente(dataNascimento: string) {
      if (!dataNascimento || dataNascimento === '0001-01-01T00:00:00' || dataNascimento === '0001-01-01') {
        return 'Data de nascimento não informada';
      }
      return DateHelper.calculaIdadePorExtenso(dataNascimento);
    },
    getSexo(sexo: number) {
      if (sexo === 0) {
        return 'Sexo Masculino';
      }
      if (sexo === 1) {
        return 'Sexo Feminino';
      }
      return 'Sexo não informado';
    },
    formatarHora(dataString: string) {
      const data = new Date(dataString);
      const hora = data.getHours().toString().padStart(2, '0');
      const minutos = data.getMinutes().toString().padStart(2, '0');
      return `${hora}:${minutos}`;
    },
    abrirModalEditarPaciente() {
      const pacienteId = this.agendamento?.paciente?.id
        ?? this.agendamento?.pacienteId
        ?? this.agendamento?.agendamentoConsulta?.pacienteId;

      if (pacienteId) {
        (this.$refs.modalEditarPaciente as any).abrirModal(pacienteId);
      }
    },
    onPacienteEditado() {
      this.$emit('pacienteEditado');
    },
  },
});
</script>

<style>
.modal-visualizar-agendamento-dialog-content {
  z-index: 2001 !important;
}
</style>

<style scoped>
/* === MODAL DETALHES DO AGENDAMENTO === */
.detalhes-agendamento-modal {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

/* === HEADER COMUM === */
.modal-header {
  background: var(--especialidade-primary, #2e4b9d);
  color: white;
  padding: 24px 32px;
  position: relative;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.header-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.header-title {
  font-size: 24px;
  font-weight: 700;
  margin: 0;
  color: white;
}

/* === CONTEÚDO UNIFICADO === */
.unified-content {
  padding: 32px;
}

.unified-card {
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.form-content {
  padding: 24px;
}

.nome-paciente {
  font-size: 1.3rem;
}

.avatar-paciente {
  align-self: start;
}

.texto-idade {
  font-size: 1rem;
}

.texto-agendado-por {
  font-size: 1.1rem;
}

.texto-usuario {
  font-size: 1rem;
}

.texto-data-hora {
  font-size: 1.1rem;
}

.texto-descricao {
  font-size: 1.2rem;
}

.texto-nome-compromisso {
  font-size: 1rem;
}

/* === AÇÕES === */
.form-actions {
  padding: 24px 32px;
  background: #f8f9fa;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.actions-container {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.action-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  padding: 0 24px !important;
  height: 48px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.3s ease !important;
}

.action-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2) !important;
}

.edit-btn {
  background: var(--especialidade-primary, #2e4b9d) !important;
  color: white !important;
}

.edit-btn:hover {
  background: var(--especialidade-secondary, #4a6cf7) !important;
}

.edit-btn:disabled {
  background: #e9ecef !important;
  color: #6c757d !important;
  box-shadow: none !important;
  transform: none !important;
}

.cancel-btn .v-icon {
  color: #ffffff !important;
}

.cancel-btn:hover {
  background: var(--especialidade-gradient, #2e4b9d) !important;
  color: #ffffff !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.cancel-btn {
  background: #dc3545 !important;
  color: white !important;
}

.icone-excluir-agendamento {
  cursor: pointer;
  position: absolute;
  right: 6px;
}

/* === RESPONSIVIDADE === */
@media (max-width: 768px) {
  .detalhes-agendamento-modal {
    border-radius: 16px;
  }

  .modal-header {
    padding: 16px 18px;
  }

  .header-title {
    font-size: 20px;
  }

  .detalhes-agendamento-modal .unified-content {
    padding: 12px !important;
  }

  .unified-card {
    border-radius: 12px;
  }

  .form-content {
    padding: 10px;
  }

  .form-actions {
    padding: 14px 12px;
  }

  .actions-container {
    flex-direction: column;
    gap: 8px;
  }

  .action-btn {
    width: 100%;
  }
}

@media (max-width: 560px) {
  .detalhes-agendamento-modal {
    width: 100%;
    max-width: 100%;
  }

  .detalhes-agendamento-modal .unified-content {
    padding: 8px !important;
  }

  .form-content {
    padding: 8px;
  }

  .form-actions {
    padding: 10px 8px;
  }

  .bloco-agendado-por {
    flex-wrap: wrap;
    justify-content: flex-start !important;
    align-items: baseline;
    gap: 4px;
  }

  .bloco-data-hora {
    justify-content: flex-start !important;
  }

  .texto-agendado-por {
    font-size: 1rem;
    margin-right: 2px !important;
  }

  .texto-usuario {
    font-size: 0.92rem;
    line-height: 1.2rem;
    word-break: break-word;
  }

  .texto-data-hora {
    font-size: 1rem;
    line-height: 1.35rem;
    word-break: break-word;
  }

  .alerta-confirmacao-agendamento {
    padding: 8px 10px !important;
  }

  .conteudo-alerta-confirmacao {
    flex-direction: column;
    align-items: stretch;
    row-gap: 8px;
  }

  .mensagem-confirmacao-agendamento {
    font-size: 0.82rem;
    line-height: 1.25rem;
    white-space: normal;
    word-break: break-word;
  }

  .acao-confirmacao-agendamento {
    width: 100%;
    max-width: 100%;
  }

  .botao-confirmacao-whatsapp {
    width: 100%;
    max-width: 100%;
    margin: 0;
    font-size: 0.72rem !important;
    letter-spacing: 0.02em;
    text-transform: none !important;
  }

  .icone-confirmacao-whatsapp {
    font-size: 16px !important;
    margin-right: 6px !important;
  }
}

@media (max-width: 480px) {
  .modal-header {
    padding: 12px 14px;
  }

  .header-title {
    font-size: 18px;
  }

  .detalhes-agendamento-modal .unified-content {
    padding: 0px !important;
  }

  .form-content {
    padding: 6px;
  }

  .form-actions {
    padding: 8px 6px;
  }

  .texto-agendado-por {
    font-size: 0.95rem;
  }

  .texto-usuario {
    font-size: 0.85rem;
    line-height: 1.05rem;
  }

  .texto-data-hora {
    font-size: 0.92rem;
    line-height: 1.2rem;
  }

  .alerta-confirmacao-agendamento {
    padding: 6px 8px !important;
  }

  .mensagem-confirmacao-agendamento {
    font-size: 0.76rem;
    line-height: 1.05rem;
  }

  .botao-confirmacao-whatsapp {
    min-height: 34px !important;
    padding: 0 8px !important;
    font-size: 0.68rem !important;
    letter-spacing: 0.01em;
  }

  .icone-confirmacao-whatsapp {
    font-size: 14px !important;
    margin-right: 4px !important;
  }
}
</style>
